import { apiClient, unwrap } from './client';
import type { ApiResponse } from '@/types/api';

export type BulkOperationType = 'ChangeProfile' | 'SendCommand' | 'Deactivate' | 'Reactivate';
export type BulkItemStatus = 'Succeeded' | 'Failed' | 'Skipped';

export interface BulkOperationRequest {
  deviceIds: number[];
  operation: BulkOperationType;
  parameter?: string | null;
  commandParametersJson?: string | null;
  continueOnError?: boolean;
}

export interface BulkOperationItemResult {
  deviceId: number;
  deviceName?: string | null;
  status: BulkItemStatus;
  message?: string | null;
}

export interface BulkOperationResult {
  total: number;
  succeeded: number;
  failed: number;
  skipped: number;
  items: BulkOperationItemResult[];
}

// El backend serializa enums como strings con la primera letra mayuscula. Los
// mapeos numericos vienen del DTO, pero con JSON converter actuan como strings.
// Si tu backend serializa como int, ajustar a usar numbers (1, 2, 3, 4).

export const bulkApi = {
  executeOnDevices(request: BulkOperationRequest): Promise<BulkOperationResult> {
    return unwrap(
      apiClient.post<ApiResponse<BulkOperationResult>>('/bulk/devices', request),
    );
  },
};
